import { CEEDERO_API_ORIGIN } from "@/api/client";
import { ROUTES } from "@/navigation/constants/routes";

export const projectHistoryPagePath = (projectId: string) =>
  `${ROUTES.catalog}/${encodeURIComponent(projectId)}/versions`;
export const projectVersionsPath = (projectId: string) =>
  `/v1/history/projects/${encodeURIComponent(projectId)}/versions`;
export const projectVersionPath = ({ projectId, id }: { projectId: string; id: string }) =>
  `${projectVersionsPath(projectId)}/${encodeURIComponent(id)}`;
export const projectVersionResourceUrl = ({
  projectId,
  id,
  resource,
}: {
  projectId: string;
  id: string;
  resource: "contents" | "preview";
}) => `${CEEDERO_API_ORIGIN}${projectVersionPath({ projectId, id })}/${resource}`;
